/* Nola — merged-line quantity control.
   BXGY automatic discounts split one variant into several cart lines (the
   discounted unit gets its own line) and the backend re-splits on every
   mutation, so the theme merges those lines VISUALLY (Liquid) and this
   script makes the quantity stepper / input / remove act on the variant's
   TOTAL quantity, re-reading fresh line keys between operations (keys
   mutate after each change). Non-merged lines keep Dawn's native handlers. */
(() => {
  const root = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const mergeable = (i) =>
    Object.keys(i.properties || {}).length === 0 && !i.selling_plan_allocation;

  const getCart = async () => (await fetch(`${root()}cart.js`)).json();

  const changeLine = async (key, quantity) => {
    const r = await fetch(`${root()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!r.ok) throw new Error('cart change failed');
    return r.json();
  };

  const sectionInner = (html, selector) => {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  };

  async function rerender() {
    const drawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      const list = cartItems.getSectionsToRender();
      const ids = list.map((s) => s.section).join(',');
      const json = await (await fetch(`${root()}?sections=${ids}`)).json();
      list.forEach((s) => {
        const target = document.getElementById(s.id);
        const inner = json[s.section] && sectionInner(json[s.section], s.selector);
        if (target && inner !== null) {
          const slot = target.querySelector(s.selector) || target;
          slot.innerHTML = inner;
        }
      });
      if (typeof cartItems.disableLoading === 'function') cartItems.disableLoading();
      return;
    }
    if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
      const ids = drawer.getSectionsToRender().map((s) => s.id).join(',');
      const sections = await (await fetch(`${root()}?sections=${ids}`)).json();
      drawer.renderContents({ sections });
      return;
    }
    window.location.reload();
  }

  let busy = false;
  async function setVariantTotal(variantId, desired) {
    if (busy) return;
    busy = true;
    try {
      desired = Math.max(0, Math.floor(desired) || 0);
      for (let guard = 0; guard < 8; guard++) {
        const cart = await getCart();
        const lines = cart.items.filter((i) => i.variant_id === variantId && mergeable(i));
        const total = lines.reduce((s, i) => s + i.quantity, 0);
        if (total === desired) break;
        if (desired === 0) {
          await changeLine(lines[0].key, 0);
          continue;
        }
        const first = lines[0];
        const target = first.quantity + (desired - total);
        await changeLine(first.key, Math.max(0, target));
      }
      await rerender();
    } catch (e) {
      window.location.reload();
    } finally {
      busy = false;
    }
  }

  // Stepper buttons (capture phase beats Dawn's own listeners)
  document.addEventListener(
    'click',
    (e) => {
      const removeBtn = e.target.closest('cart-remove-button[data-nb-merged]');
      if (removeBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setVariantTotal(Number(removeBtn.dataset.nbMerged), 0);
        return;
      }
      const btn = e.target.closest('.quantity__button');
      if (!btn) return;
      const qi = btn.closest('quantity-input');
      const input = qi && qi.querySelector('input[data-nb-merged]');
      if (!input) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const current = Number(input.value) || 0;
      const desired = btn.name === 'plus' ? current + 1 : current - 1;
      input.value = Math.max(0, desired);
      setVariantTotal(Number(input.dataset.nbMerged), desired);
    },
    true
  );

  // Direct typing in the input
  document.addEventListener(
    'change',
    (e) => {
      const input = e.target.closest && e.target.closest('input[data-nb-merged]');
      if (!input) return;
      e.stopImmediatePropagation();
      setVariantTotal(Number(input.dataset.nbMerged), Number(input.value));
    },
    true
  );
})();
